import HttpService from './httpService';

const LoginService = {
    logLogin: async () => {
        return HttpService.post("api/v1/log/login");
    },
};

export default LoginService;
